/**
 @flow
 */

import { parseEncodedTextFromString } from "../../../../common/webpack/shared/utils/htmlParsingUtils";

export type RawOccupation = {
  id: number,
  long_description: string,
  desc: string,
  job_code: number,
  occupation_class: number,
  union: number,
  display_str: string,
};

export type Occupation = {
  id: number,
  longDescription: string,
  description: string,
  jobCode: number,
  occupationClassID: number,
  unionID: number,
  displayStr: string,
};

export const parseRawOccupation = (rawOccupation: RawOccupation): Occupation => {
  // eslint-disable-next-line camelcase
  const { id, long_description, ...rest } = rawOccupation;

  return {
    id,
    longDescription: parseEncodedTextFromString(long_description),
    description: parseEncodedTextFromString(rest.desc),
    jobCode: rest.job_code,
    occupationClassID: rest.occupation_class,
    unionID: rest.union,
    displayStr: parseEncodedTextFromString(rest.display_str),
  };
};

export const parseRawOccupationArray = (rawOccupationArray: Array<RawOccupation>): Array<Occupation> =>
  rawOccupationArray.map(parseRawOccupation);
